<template>
  <div>
    <Head title="Create Purchase Request" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/stockouts">
        Pengeluaran Barang
      </Link>
      <span class="text-indigo-400 font-medium"> / </span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pb-8 pr-6 flex flex-col w-full md:w-1/2">
            <label for="trn_date">Tanggal:</label>
            <flat-pickr
              v-model="form.trn_date"
              :error="form.errors.trn_date"
              class="p-2 w-full border rounded mt-2"
              name="recv_date" />
            <div v-if="form.errors.trn_date" class="form-error">
              {{ form.errors.trn_date }}
            </div>
          </div>
          <select-input
            v-model="form.purchase_request_id"
            :error="form.errors.purchase_request_id"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Purchase Request">
            <option
              v-for="purchaseReq in purchaseReqs"
              :key="purchaseReq.id"
              :value="purchaseReq.id">
              {{ purchaseReq.code }}
            </option>
          </select-input>
          <text-input
            v-model="form.activity_name"
            :error="form.errors.activity_name"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Nama Aktivitas" />
          <select-input
            v-model="form.item_location_id"
            :error="form.errors.item_location_id"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Lokasi Item">
            <option
              v-for="itemLocation in itemLocations"
              :key="itemLocation.id"
              :value="itemLocation.id">
              {{ itemLocation.name }}
            </option>
          </select-input>
          <textarea-input
            v-model="form.desc"
            :error="form.errors.desc"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Description" />
          <textarea-input
            v-model="form.kepada"
            :error="form.errors.kepada"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Kepada" />
          <select-input
            v-model="form.signature01_id"
            :error="form.errors.signature01_id"
            class="pb-8 pr-6 w-1/2 md:w-1/3"
            label="Mengetahui">
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id">
              {{ employee.name }}
            </option>
          </select-input>
          <text-input
            v-model="form.signature02_id"
            :error="form.errors.signature02_id"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Menerima" />
          <text-input
            v-model="form.signature03_id"
            :error="form.errors.signature03_id"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Mengeluarkan" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Create Pengeluaran Barang
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextareaInput,
        TextInput,
        flatPickr,
    },
    layout: Layout,
    props: {
        stockOuts: Object,
        purchaseReqs: Object,
        itemLocations: Object,
        employees: Object,
    },
    remember: 'form',
    data () {
        return {
            form: this.$inertia.form({
                trn_date: null,
                purchase_request_id: null,
                activity_name: null,
                item_location_id: null,
                desc: null,
                kepada: null,
                signature01_id: null,
                signature02_id: null,
                signature03_id: null,
            }),
        }
    },
    methods: {
        store () {
            this.form.post('/stockouts')
        },
    },
}
</script>
